import { render, staticRenderFns } from "./LsAiAssistant.vue?vue&type=template&id=e0b6d890&"
import script from "./LsAiAssistant.vue?vue&type=script&lang=js&"
export * from "./LsAiAssistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports